module.exports = __webpack_public_path__ + "img/Membership.d8370a49.svg";